import React                          from 'react';
import { FunctionalityLockMark }      from '@/components/Functionality';
import { FunctionalityLockMarkQuery } from '@/components/Functionality';

// NOTE: dans un menu déroulant, cliquer une entrée déclenche son action quel que soit son contenu :
// un gate ne peut pas l'arrêter. L'entrée ne montre donc que la couronne, et l'action se vérifie
// elle-même (voir `functionalityGuards`).
export const withLockMark = (query: FunctionalityLockMarkQuery) => (content: React.ReactNode) => (
	<span style={{ alignItems: 'center', display: 'inline-flex', gap: 6 }}>
		{content}
		<FunctionalityLockMark {...query} />
	</span>
);
